import { useNavigate } from 'react-router-dom'

export const RegistrationSuccess = () => {
  const navigate = useNavigate()

  return (
    <div className="text-center space-y-6 py-8 px-4">
      <h1 className="text-3xl font-bold text-primary">Registration Successful!</h1>

      <p className="text-gray-700">
        We&#39;ve sent a confirmation email to your inbox.
        <br />
        Please check your email (and possibly your spam folder) to confirm your address.
      </p>

      <div className="border-t border-gray-300 my-4" />

      <p className="text-bold text-gray-700">
        After confirming your email and logging in, visit the <strong>Billing</strong> section to choose your subscription plan.
      </p>

      <button
        className="btn btn-primary"
        onClick={() => navigate('/')}
      >
        Go to Login
      </button>
    </div>
  )
}